<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment" style="padding-top:150px">
<p><em>This is a story of how abandonment, betrayal, and eventually courage can foster the birth of a renewed soul and mind through the passageway of forgiveness. Birthed Anew is the portrayed revelation of one’s authentic journey through self-identification, self-reflection, self-expression, self-discovery, self-renewal, and lastly the pinnacle of self-love which is the key ingredient to the development of a whole person. The bitterness of life can afford the opportunity to seek growth and betterment as we aim to maximize our truest and fullest potential as essential contributors to society.</em></p>
<p><em><br/>
</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?0525ea18